export default "__VITE_ASSET__CYWwohoC__"